import React from 'react'
import ImageHeader from '../../component/ImageHeader';
import ContactHead from '../Contact/ContactHead';
import CuisineTreat from '../cuisine/CuisineTreat';
import SpaFaqs from './SpaFaqs';
import CuisineStart from '../cuisine/CuisineStart';

export default function Spa() {

  const imageHead = {
    title: 'Feel Good — The Heart of Wellness at De Coração',
    image: "/image/spa-banner.webp",
    breadcrumb: [
      {
        slug: "/resort-de-coracao-corbett",
        name: "Jim Corbett",
      },
      {
        name: "Spa & Wellness",
      },
    ]
  }

  const quoteHead = {
    desc: "At De Coração, wellness is more than just a treatment; it’s about finding your center again. After a day spent in the wild, there is nothing quite like retreating to a space filled with peaceful aromas and soft music. Whether you choose a deep-tissue ritual or a soothing therapy session, our goal is to help you shed the stress of the city. Surrounded by the quiet stillness of the Corbett landscape and supported by our attentive, personal care, every moment here is designed to revitalize your body and clear your mind.",
    title: "An Overview",
  };

  const treatData = {
    leftImg: "/image/spa-relex-1.webp",
    rightImg: "/image/spa-relex-2.webp",
    title: "Sanctuary of Relaxation & Renewals",
  }

  const startData = {
    title: "Your Forest Oasis of Quiet Luxury",
    desc: "<p>Wellness at De Coração is a curated experience that blends holistic traditions with modern expert care. Our spa features a bespoke menu of signature massages and treatments, all set within a space designed to reflect the natural beauty of our surroundings. It’s a place to slow down, breathe deeply, and embrace renewal. Whether you are here to recover from a long journey or simply want to indulge in some much-needed me time, we provide the perfect sanctuary to rejuvenate your senses.</p>",
    topLeftImg: "/image/spa-gallery-1.webp",
    topRightImg: '/image/spa-gallery-2.webp',
    bottomImg: "/image/spa-gallery-3.webp",
  }

  const treatData2 = {
    leftImg: "/image/spa-detox-1.webp",
    rightImg: "/image/spa-detox-2.webp",
    title: "Forest-Inspired Ayurvedic Healing",
  }

  const startFaqData = [
    {
      title: "Abhyangam",
      desc: "Abhyangam is an ancient Ayurvedic relaxing massage technique in which oils are selected according to your body type. It helps cleanse accumulated ama or toxins, caused by an unhealthy lifestyle. The therapy supports renewals, rejuvenates the body, promotes healthy ageing, and enhances stamina and immunity.",
      duration: "Duration: 60 to 90 minutes",
    },
    {
      title: "Pathrapinda Swednam",
      desc: "Pathrapinda Swednam is a traditional ayurvedic treatment where warm herbal rice boluses are used to massage the body, promoting circulation and relieving tension.",
      duration: "Duration: 60 to 90 minutes",
    },
    {
      title: "Churna Pinda Swednam",
      desc: "Churna Pinda Swednam is a rejuvenating treatment where warm herbal powders are used to massage the body, promoting circulation and relieving tension.",
      duration: "Duration: 60 to 90 minutes",
    },
    {
      title: "Netra Kshalanam",
      desc: "Netra Kshalanam is a traditional ayurvedic eye treatment that involves the use of medicated oils to cleanse and soothe the eyes.",
      duration: "Duration: 60 to 90 minutes",
    },
    {
      title: "Kavala Gandusha",
      desc: "Kavala Gandusha is a traditional ayurvedic treatment where medicated oils are used to gargle, promoting oral health and relieving throat irritation.",
      duration: "Duration: 60 to 90 minutes",
    },

  ];

  const FaqData = [
    {
      title: "Kati Vasti",
      desc: "A deeply grounding therapy focused on the lower back, Kati Vasti uses warm medicated oils retained within a herbal dough ring. Surrounded by Corbett’s serene wilderness, it helps ease stiffness, improve flexibility, and relieve chronic back discomfort. Ideal after long safaris or travel fatigue.",
      duration: "Duration: 30 to 45 minutes",
    },
    {
      title: "Pichu",
      desc: "Pichu involves placing a soft cloth soaked in warm herbal oil over a specific area to gently nourish and heal tissues. This calming treatment is perfect for localized pain, inflammation, or stress relief. The tranquil forest setting enhances its soothing effect.",
      duration: "Duration: 20 to 30 minutes",
    },
    {
      title: "Uro Vasti",
      desc: "Designed for the chest region, Uro Vasti uses warm medicated oils to support respiratory health and emotional balance. It helps release congestion and promotes relaxation, making it ideal for those seeking deeper breath and calm.",
      duration: "Duration: 30 to 40 minutes",
    },
    {
      title: "Janu Vasti",
      desc: "A targeted knee therapy where warm herbal oil is retained over the joint to reduce stiffness and discomfort. Especially beneficial after nature walks or outdoor activities, it supports joint mobility and strength.",
      duration: "Duration: 30 to 40 minutes",
    },
    {
      title: "Greeva Vasti",
      desc: "Focused on the neck and cervical region, this therapy helps relieve tension caused by poor posture or travel strain. Warm oils deeply penetrate muscles, easing stiffness and restoring movement.",
      duration: "Duration: 30 to 40 minutes",
    },
    {
      title: "Hridya vasti",
      desc: "A heart-centered therapy that gently works on the chest area using warm medicated oils. It promotes emotional balance, reduces stress, and creates a sense of inner calm amidst Corbett’s peaceful surroundings.",
      duration: "Duration: 30 to 40 minutes",
    },
    {
      title: "The Ayurvedic Kansa Vatki Foot Massage",
      desc: "Using a traditional Kansa bowl, this foot massage stimulates pressure points and improves circulation. It detoxifies the body while inducing deep relaxation — perfect after a day in the wild.",
      duration: "Duration: 30 to 45 minutes",
    }
  ];

  return (
    <>
      <ImageHeader imageHead={imageHead} />
      <ContactHead quoteHead={quoteHead} />
      <CuisineTreat data={treatData} isCuisine={false} />
      <SpaFaqs data={startFaqData} />
      <CuisineStart data={startData} isCuisine={false} headingTag="h2"/>
      <CuisineTreat data={treatData2} isCuisine={false} headingTag="h3"/>
      <SpaFaqs data={FaqData} />
    </>
  )
}
